/** Route and stop planning are editable until the Trip reaches a terminal state. */
export function isTripRoutingEditable(status: string): boolean {
  return status === "PLANNED" || status === "ACTIVE";
}
